import { render, staticRenderFns } from "./ReservedSessionsModule.vue?vue&type=template&id=4611aef6&lang=pug"
import script from "./ReservedSessionsModule.vue?vue&type=script&lang=js"
export * from "./ReservedSessionsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports